import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
// api
import Api from '@/api'
import {AppType} from '@/enum'
import {IsManagerPro} from '@/utils'


/**
 * mysql表单项
 * @constructor
 */
const OracleDataBaseFormItems = () => {

  return (
    <>
      <ProFormText
        name={["config", "url"]}
        label={"地址"}
        placeholder={"请输入数据库连接地址"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入数据库连接地址"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
        ]}
      />
      <ProFormText
        name={['config', 'name']}
        label={"用户名"}
        placeholder={"请输入用户名"}
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入用户名"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
        ]}
      />
      <ProFormText
        name={['config', 'password']}
        label={"密码"}
        placeholder={"请输入密码"}
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入密码"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
        ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />     
    </>
  )
}

export default OracleDataBaseFormItems
